import { Props } from "./types";
import {
  Box,
  Button,
  IconButton,
  Slider,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { styles } from "./styles";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import { VolumeDown, VolumeUp } from "@mui/icons-material";
import { useContext } from "react";
import { AuthContext, AuthContextInterface } from "../../../contexts";
import { APP_COLOR } from "../../../theme";

const DawControls: React.FC<Props> = ({
  isPlaying,
  bpm,
  volume,
  totalTracksCount,
  handlePlayStop,
  handleIncrementBpm,
  handleDecrementBpm,
  handleVolumeChange,
  handleIncrementVolume,
  handleDecrementVolume,
  handleExport,
}) => {
  const authContext: AuthContextInterface = useContext(AuthContext);

  return (
    <div style={styles.controls}>
      <Stack
        spacing={2}
        direction="row"
        sx={{ margin: "0px 20px" }}
        alignItems="center"
      >
        <IconButton aria-label="play/stop" onClick={handlePlayStop}>
          {isPlaying ? (
            <StopCircleIcon sx={styles.icons} />
          ) : (
            <PlayArrowIcon sx={styles.icons} />
          )}
        </IconButton>
      </Stack>
      <Stack
        spacing={2}
        direction="row"
        sx={{ margin: "0px 20px" }}
        alignItems="center"
      >
        <Button
          variant="contained"
          size="small"
          onClick={handleDecrementBpm}
          disableRipple
          sx={styles.bpmButtons}
        >
          <Typography sx={{ fontSize: "4" }}>-</Typography>
        </Button>
        <Typography
          sx={{ fontSize: "4", color: "white" }}
        >{`${bpm} bpm`}</Typography>
        <Button
          variant="contained"
          size="small"
          disableRipple
          onClick={handleIncrementBpm}
          sx={styles.bpmButtons}
        >
          <Typography sx={{ fontSize: "4" }}>+</Typography>
        </Button>
      </Stack>
      <Box sx={{ width: 200 }}>
        <Stack
          spacing={2}
          direction="row"
          sx={{ margin: "0px 20px" }}
          alignItems="center"
        >
          <IconButton
            onClick={handleDecrementVolume}
            disableRipple
            sx={styles.icons}
          >
            <VolumeDown />
          </IconButton>
          <Slider
            aria-label="Volume"
            value={volume}
            onChange={handleVolumeChange}
            sx={{ color: APP_COLOR }}
            min={0}
            max={30}
          />
          <IconButton
            onClick={handleIncrementVolume}
            disableRipple
            sx={styles.icons}
          >
            <VolumeUp />
          </IconButton>
        </Stack>
      </Box>
      {authContext?.userId ? (
        <Button
          variant="contained"
          sx={styles.exportBtn}
          onClick={handleExport}
          disabled={totalTracksCount === 0}
          disableRipple
        >
          Export for minting
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DawControls;
